import { useEffect } from "react";
import CategorySelect from "./components/CategorySelect";
import GamesList from "./components/GamesList";
import Pagination from "./components/Pagination";
import { useDispatch, useSelector } from "react-redux";
import { fetchGames, fetchCatalogFiltersData } from "./features/catalog/catalogSlice";
import FeatureTags from "./components/filters/FeatureTags";
import MobileFilters from "./components/filters/MobileFilters";
import FiltersBy from "./components/filters/FiltersBy";
import SortBy from "./components/filters/SortBy";

function App() {
  const {
    currentCategoryId,
    selectedFeatureTags,
    selectedVolatilityOptions,
    selectedPaylinesMin,
    selectedPaylinesMax,
    selectedMultiplierMin,
    selectedMultiplierMax,
    sortBy,
    sortDirection,
    catalogLoading
  } = useSelector((state) => state.catalog);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchCatalogFiltersData({}));
  }, []);

  useEffect(() => {
    if (catalogLoading) {
      return;
    }

    dispatch(fetchGames({ page: 1 }));
  }, [
    dispatch,
    catalogLoading,
    currentCategoryId,
    selectedFeatureTags,
    selectedVolatilityOptions,
    selectedPaylinesMin,
    selectedPaylinesMax,
    selectedMultiplierMin,
    selectedMultiplierMax,
    sortBy,
    sortDirection
  ]);

  return (
    <div className="games-catalog">
      {!catalogLoading && <>
        <CategorySelect />
        <FeatureTags />
        <MobileFilters />
        {/* <div className="filters-sort-wrapper">
          <FiltersBy />
          <SortBy />
        </div> */}
        <GamesList />
        <Pagination />
      </>}
    </div>
  )
}

export default App;
